export const uploadFilePath = {
  logo: "images/company_logo",
  banner: "images/company_banner",
  authLetters: "files/authorized_letters",
  tradeLicense: "files/trade_licenses",
  moa: "files/moa",
  vat: "files/vat_certificates",
  bank: "files/bank_conf_letter",
  auditedFinancial: "files/audited_financial_statement",
  supportScreenshot: "files/support_screenshot",
  userProfile: "images/profiles",
  tax: "files/tax_certificates",
  enterprise: "files/enterprise",
};

/* The upload CATEGORIES the backend accepts — UPLOAD_CATEGORIES in app/company/utils/s3_paths.py, mirrored here. */
export const UPLOAD_CATEGORIES = [
  "company_logo",
  "company_banner",
  "trade_license_staging",
  "trade_license",
  "vat_certificate",
  "moa",
  "tax_document",
  "financial_document",
  "financial_statement",
  "bank_letter",
  "auth_letter",
  "supporting_document",
  "brief",
  "tickets",
  "user_profile_image",
  "article_banner",
  "article_image",
  "enterprise",
  "admin_trade_license_old",
  "admin_trade_license_new",
];
